import { render, staticRenderFns } from "./SendLinkToCreateReports.vue?vue&type=template&id=63f26988&"
import script from "./SendLinkToCreateReports.vue?vue&type=script&lang=js&"
export * from "./SendLinkToCreateReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports